import {
  Alert,
  Dialog,
  FormStack,
  MenuItem,
  SelectField,
  Stack,
  TextField,
  Typography,
} from '@all-manager/design-system-v2';
import { Controller } from 'react-hook-form';
import { useCreateSubTopicFromInboxModal } from './useCreateSubTopicFromInboxModal';

type Props = {
  open: boolean;
  onClose: () => void;
  initialTitle?: string | null;
  onSuccess: (newSubTopicId: string) => void;
};

export default function CreateSubTopicFromInboxModal(props: Props) {
  const hook = useCreateSubTopicFromInboxModal(props);

  return (
    <Dialog
      open={props.open}
      onClose={props.onClose}
      maxWidth="sm"
      fullWidth
      title="Créer un nouveau sujet"
      closeLabel="Fermer"
      onSubmit={hook.handleSubmit}
      actions={{
        primaryAction: {
          label: 'Créer le sujet',
          type: 'submit',
          loading: hook.isSubmitting,
          disabled: hook.isSubmitting,
        },
        secondaryAction: {
          label: 'Annuler',
          onClick: props.onClose,
          disabled: hook.isSubmitting,
        },
      }}
    >
      <Stack spacing={2}>
        <Typography variant="body2">
          Ce dossier servira de rattachement pour les devis et interventions de cet e-mail.
        </Typography>

        {hook.serverError && (
          <Alert severity="error">
            {hook.serverError}
          </Alert>
        )}

        <FormStack>
          <Controller
            name="name"
            control={hook.form.control}
            render={function renderNameField({ field, fieldState }) {
              return (
                <TextField
                  {...field}
                  label="Nom du sujet / dossier"
                  fullWidth
                  size="small"
                  error={Boolean(fieldState.error)}
                  helperText={fieldState.error?.message}
                  autoFocus
                />
              );
            }}
          />

          <Controller
            name="topicId"
            control={hook.form.control}
            render={function renderTopicSelect({ field, fieldState }) {
              return (
                <SelectField<string>
                  {...field}
                  label="Grand dossier / Thème parent"
                  fullWidth
                  size="small"
                  error={Boolean(fieldState.error)}
                  helperText={fieldState.error?.message || 'Sélectionnez le dossier parent (ex: Travaux, Contrats...)'}
                  disabled={hook.isLoadingTopics}
                >
                  {hook.topics.map(function renderOption(topic) {
                    return (
                      <MenuItem key={topic.id} value={topic.id}>
                        {topic.name}
                      </MenuItem>
                    );
                  })}
                </SelectField>
              );
            }}
          />
        </FormStack>
      </Stack>
    </Dialog>
  );
}
